
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import VXETable from "vxe-table";

import { addInquirySheet } from "@/api/inquiry";
import { getRelationPaymentVoucher, removeRelation, addRelation } from "@/api/supplier-payment";
import { COMPANY_LIST } from "@/constant";
import {
  searchCustomer
} from "@/api/customer";

@Component({
  name: "CreateFee",
  components: {
    ChoosePayment: () => import("./ChoosePayment.vue")
  }
})
export default class extends Vue {
  @Prop({ default: false }) private show: boolean;
  @Prop({ default: "其他费用" }) private title: "";
  @Prop({ default: "" }) private id: "";
  @Prop({ default: "" }) private supplierId: "";
  @Prop({ default: true }) private showBtnStatus: boolean;

  private showChoose = false;
  private form = {
    customerId: null,
    company: null
  };
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any[]
  };
  public tableCol = [
    {
      label: "付款单号",
      prop: "code",
      key: "code",
      show: true,
      disabled: false
    },
    {
      label: "付款类型",
      prop: "type",
      key: "type",
      show: true,
      disabled: false
    },
    {
      label: "付款金额",
      prop: "paymentAmount",
      key: "paymentAmount",
      show: true,
      disabled: false
    },
    {
      label: "单据剩余",
      prop: "paymentRemaining",
      key: "paymentRemaining",
      show: true,
      disabled: false
    },
    {
      label: "本次使用",
      prop: "useAmount",
      key: "useAmount",
      show: true,
      disabled: false,
      type: "inputNumber",
      precision: 4
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        {
          name: "删除",
          code: '',
          click: "handleDelete",
          type: "delete"
        }
      ],
      show: true,
      disabled: false,
      width: 100
    }
  ] as any;

  public tableCol1 = [
    {
      label: "付款单号",
      prop: "code",
      key: "code",
      show: true,
      disabled: false
    },
    {
      label: "付款类型",
      prop: "type",
      key: "type",
      show: true,
      disabled: false
    },
    {
      label: "付款金额",
      prop: "paymentAmount",
      key: "paymentAmount",
      show: true,
      disabled: false
    },
    {
      label: "单据剩余",
      prop: "paymentRemaining",
      key: "paymentRemaining",
      show: true,
      disabled: false
    },
    {
      label: "本次使用",
      prop: "useAmount",
      key: "useAmount",
      show: true,
      disabled: true,
      type: "inputNumber",
      precision: 4
    }
  ] as any;

  private list = [
    {
      label: "公司",
      prop: "company",
      key: "company",
      type: "select",
      placeholder: "请选择公司",
      clearable: true,
      maxlength: 100,
      rules: {
        required: true,
        message: "请选择公司",
        trigger: "change"
      },
      options: COMPANY_LIST
    },
    {
      label: "客户",
      prop: "customerId",
      key: "customerId",
      type: "select",
      value: "",
      placeholder: "请选择客户",
      remote: true,
      remote_method: this.getCustomer,
      clearable: true,
      options: [],
      rules: {
        required: true,
        message: "请选择客户",
        trigger: "change"
      },
      labelKey: "abbreviation",
      valueKey: "id"
    }
  ];
  private options = [];
  private value = "";

  private relationPaymentVoucherResListGIVE(item) {
    console.log('传过来的关联付款单',item)
    this.table.list = item;
  }

  private close() {
    this.$emit("update:show", false);
  }

  private open() {
    this.$emit("update:show", true);
  }
  private async inputChange({ val, row, column }) {
    console.log(column.key);
    const { paymentRemaining, useAmount } = row.row;
    if (useAmount > paymentRemaining) {
      this.$set(row.row, "useAmount", paymentRemaining);
    }
  }
  //  删除
  public async handleDelete(scope) {
    this.table.list.splice(scope.$index, 1);

  }

  private async getCustomer(name = "") {
    const res: any = await searchCustomer({ keyword: name });
    this.list[1].options = res;
  }

  private handleAdd() {
    if (!this.supplierId) {
      this.$notify({
        title: "提示",
        message: "请先选择供应商",
        type: "error",
        duration: 2000
      });
      return;
    }
    this.showChoose = true;
  }

  private async addRelation(list) {
    console.log(list);
    this.table.list = list;
  }
}
